import {
  type ParsedElicitation,
  type RenderableElicitation,
} from '~/components/v2/components/workspace/workspace-agent-panel/schemas/elicitation';

/** Only the first renderable elicitation is shown — docks share one anchor and would stack invisibly. */
export const getPendingConsentDockElicitation = (
  pendingElicitations: ParsedElicitation[],
): RenderableElicitation | null => {
  for (const entry of pendingElicitations) {
    if (entry.elicitation) {
      return entry.elicitation;
    }
  }

  return null;
};
